module.exports = __webpack_public_path__ + "static/media/share_1.a36eb6fb.png";